export initialState = {
  node: undefined
  isLoading: true
}

export reducer = (state, { type, payload }) ->
  try
    switch (type)
      when 'SET_NODE'
        { state..., node: payload.data }
      when 'SET_LOADING'
        { state..., isLoading: payload.data }
      else
        throw new Error("DetailData reducer recieved an invalid action type (#{ type }).")
  catch e
    console.error(e)
